// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"0b0127bc","182":"13da7cfb","463":"bfa2d436","621":"c5f39f83","787":"d0aae870"}[chunkId] + ".chunk.js";
};